<div class="flex min-h-screen items-center justify-center bg-slate-50 px-4 py-12 font-sans">
  <div class="w-full max-w-sm">

    <!-- Logo + heading -->
    <div class="mb-8 flex flex-col items-center text-center">
      <div class="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-violet-600 shadow-sm">
        <lucide-icon name="zap" [size]="22" color="white" [strokeWidth]="2.5"></lucide-icon>
      </div>
      <h1 class="text-xl font-semibold text-slate-900">Create your account</h1>
      <p class="mt-1.5 text-sm text-slate-500">Get started with KernalHQ for free</p>
    </div>

    <!-- Card -->
    <div class="rounded-2xl border border-slate-200 bg-white px-6 py-7 shadow-sm">
      <form #signupForm="ngForm" (ngSubmit)="onSubmit()">

        <!-- Error banner -->
        <div *ngIf="error" class="mb-5 flex items-start gap-3 rounded-lg border border-red-200 bg-red-50 px-4 py-3">
          <lucide-icon name="triangle-alert" [size]="15" class="mt-0.5 flex-shrink-0 text-red-500" [strokeWidth]="2"></lucide-icon>
          <p class="text-sm text-red-700">{{ error }}</p>
        </div>

        <!-- Name row -->
        <div class="mb-4 flex gap-3">
          <div class="flex-1">
            <label for="givenName" class="mb-1.5 block text-xs font-medium text-slate-700">First name</label>
            <input
              id="givenName"
              type="text"
              name="givenName"
              [(ngModel)]="givenName"
              required
              autocomplete="given-name"
              placeholder="Alex"
              class="block w-full rounded-lg border border-slate-200 bg-white px-3.5 py-2.5 text-sm text-slate-900 placeholder:text-slate-400 focus:border-violet-400 focus:outline-none focus:ring-2 focus:ring-violet-100 transition-shadow"
            />
          </div>
          <div class="flex-1">
            <label for="familyName" class="mb-1.5 block text-xs font-medium text-slate-700">Last name</label>
            <input
              id="familyName"
              type="text"
              name="familyName"
              [(ngModel)]="familyName"
              required
              autocomplete="family-name"
              placeholder="Jordan"
              class="block w-full rounded-lg border border-slate-200 bg-white px-3.5 py-2.5 text-sm text-slate-900 placeholder:text-slate-400 focus:border-violet-400 focus:outline-none focus:ring-2 focus:ring-violet-100 transition-shadow"
            />
          </div>
        </div>

        <!-- Email -->
        <div class="mb-4">
          <label for="email" class="mb-1.5 block text-xs font-medium text-slate-700">Work email</label>
          <input
            id="email"
            type="email"
            name="email"
            [(ngModel)]="email"
            required
            autocomplete="email"
            placeholder="you@company.com"
            class="block w-full rounded-lg border border-slate-200 bg-white px-3.5 py-2.5 text-sm text-slate-900 placeholder:text-slate-400 focus:border-violet-400 focus:outline-none focus:ring-2 focus:ring-violet-100 transition-shadow"
          />
        </div>

        <!-- Password -->
        <div class="mb-6">
          <label for="password" class="mb-1.5 block text-xs font-medium text-slate-700">Password</label>
          <input
            id="password"
            type="password"
            name="password"
            [(ngModel)]="password"
            required
            minlength="12"
            autocomplete="new-password"
            placeholder="Min. 12 characters"
            class="block w-full rounded-lg border border-slate-200 bg-white px-3.5 py-2.5 text-sm text-slate-900 placeholder:text-slate-400 focus:border-violet-400 focus:outline-none focus:ring-2 focus:ring-violet-100 transition-shadow"
          />
        </div>

        <!-- Submit -->
        <button
          type="submit"
          [disabled]="loading || !signupForm.valid"
          class="flex w-full items-center justify-center gap-2 rounded-lg bg-violet-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60"
        >
          <lucide-icon *ngIf="loading" name="loader" [size]="15" class="animate-spin" [strokeWidth]="2.5"></lucide-icon>
          {{ loading ? 'Creating account...' : 'Create account' }}
        </button>

      </form>
    </div>

    <p class="mt-5 text-center text-sm text-slate-500">
      Already have an account?
      <a routerLink="/login" class="font-medium text-violet-600 hover:underline">Sign in</a>
    </p>
    <p class="mt-4 text-center text-xs text-slate-400">&copy; 2026 KernalHQ. All rights reserved.</p>
  </div>
</div>
